import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store';
import { getChest } from '../../store/reducers/chests/asyncActions';
import ChestContent from './components/ChestContent';
import ChestHeading from './components/ChestHeading';
import { TChestRewardHistory } from '../../types';

function Chest() {
  const dispatch = useAppDispatch();

  const { activeChest } = useAppSelector(({ chests }) => chests);
  const [rewardToCollect, setRewardToCollect] = useState<TChestRewardHistory>();

  const params = useParams();

  useEffect(() => {
    if (!activeChest && params.id) {
      dispatch(getChest({ id: params.id }));
    }
  }, []);

  if (!activeChest) {
    return null;
  }

  return (
    <div className="pt-[99px]">
      <div className="absolute bg-chestPageBg bg-cover top-0 left-0 w-full h-full " />
      <ChestHeading hasContains chest={activeChest} rewardToCollect={rewardToCollect} />
      <ChestContent setRewardToCollect={setRewardToCollect} rewardToCollect={rewardToCollect} />
    </div>
  );
}

export default Chest;
